import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import { signin, app_logout, generate_otp } from './api';
import LocalStorage from 'utilities/localStorage';
import { history } from 'app/history';

const initialState = {
  loading: false,
  accessToken: '',
  user_details: null,
  otploading: false
};

const actions = {
  LOGIN: 'login/LOGIN',
  LOGOUT: 'logout/LOGOUT',
  GET_GENERATEOTP: 'get_generateOTP/GET_GENERATEOTP'
};

export const login = createAsyncThunk(actions.LOGIN, async (payload) => {
  const response = await signin(payload);

  // console.log('response?.access_token', response?.accessToken);
  if (response?.accessToken) {
    const { accessToken, user_details } = response;
    let newUser = {
      accessToken,
      user_details
    };

    LocalStorage.setItem('MAT-User', JSON.stringify(newUser));
    if (newUser.accessToken) {
      history.push('/dashboard');
    }
  } else {
    localStorage.clear();
    logout();
    // message.success('Logged out successfully');
    // const messageText = response.message || 'Logged out successfully';
    // message.error(messageText);
    history.push('/login');
  }

  return response;
});

// logout/LOGOUT
// export const logout = createAsyncThunk(actions.LOGOUT, async (payload) => {
//   console.log('payload', payload);
//   const response = await app_logout(payload);
//   localStorage.clear();
//   dispatch(resetLoginDetails());
//   history.push('/login');
//   return response;
// });
export const logout = createAsyncThunk(
  actions.LOGOUT,
  async (payload, { dispatch }) => {
    try {
      // Make the backend logout API call
      const response = await app_logout(payload);

      if (response?.success === true) {
        // Adjust condition based on your API response structure
        // Clear local storage upon successful logout
        localStorage.clear();

        // Dispatch any Redux action to reset state
        dispatch(resetLoginDetails());

        // Redirect to the login page
        history.push('/login');
      } else {
        // Handle any non-successful response if needed
        console.error('Logout failed:', response);
      }

      return response;
    } catch (error) {
      // Handle any errors that occur during the logout request
      console.error('Error during logout:', error);
      throw error; // Optionally, re-throw the error to handle it in the component if needed
    }
  }
);
// get_generateOTP/GET_GENERATEOTP
export const get_generateOTP = createAsyncThunk(
  actions.GET_GENERATEOTP,
  async (payload) => {
    // console.log('payload', payload);
    const response = await generate_otp(payload);
    return response;
  }
);

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    resetLoginDetails: (state) => {
      state.accessToken = '';
      state.user_details = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        const { data, success, message: msg } = action.payload;
        state.loading = false;
        state.accessToken = data?.access_token;
        state.user_details = data?.user;

        if (success) {
          message.success(msg, [1]);
        } else {
          message.error(msg);
        }
      })
      .addCase(login.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    //
    builder
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;

        if (success) {
          message.success(msg, [1]);
        } else {
          message.error(msg);
        }
      })
      .addCase(logout.rejected, (state, action) => {
        const { message: msg } = action.error;

        state.loading = false;

        message.error(msg);
      });
    // get_generateOTP
    builder
      .addCase(get_generateOTP.pending, (state) => {
        state.otploading = true;
      })
      .addCase(get_generateOTP.fulfilled, (state) => {
        // const { success, message: msg } = action.payload;
        state.otploading = false;
      })
      .addCase(get_generateOTP.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.otploading = false;
        message.error(msg);
      });
  }
});

export const { resetLoginDetails } = loginSlice.actions;

// export const logout = () => (dispatch) => {
//   localStorage.clear();
//   dispatch(resetLoginDetails());
//   message.success('Thanks! You have logged out successfully');
//   history.push('/login');
// };

export default loginSlice.reducer;
